import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, TrainFront, Wallet } from 'lucide-react';

const quickLinks = [
  {
    name: 'Naas',
    saving: '€575/mo',
    path: '/compare/renting-in-dublin-vs-naas',
  },
  {
    name: 'Drogheda',
    saving: '€705/mo',
    path: '/compare/renting-in-dublin-vs-drogheda',
  },
  {
    name: 'Navan',
    saving: '€740/mo',
    path: '/compare/renting-in-dublin-vs-navan',
  },
];

const DublinCommuterWidget: React.FC = () => {
  return (
    <aside className="rounded-3xl border border-emerald-200 bg-gradient-to-br from-emerald-50 to-white p-6 md:p-7 shadow-sm mb-8">
      <div className="inline-flex items-center gap-2 rounded-full border border-emerald-200 bg-white px-3 py-1 text-[10px] font-black uppercase tracking-widest text-emerald-700 mb-3">
        <TrainFront className="h-3.5 w-3.5" /> Dublin Commuter Belt
      </div>
      <h2 className="text-2xl font-black text-slate-900 mb-2">Priced out?</h2>
      <p className="text-sm text-slate-600 font-medium mb-5 leading-relaxed">
        See how much you could save in nearby commuter towns after commute costs.
      </p>

      <div className="space-y-2">
        {quickLinks.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className="no-underline flex items-center justify-between rounded-2xl border border-slate-200 bg-white px-4 py-3 hover:border-emerald-300 hover:-translate-y-0.5 hover:shadow-md transition-all"
          >
            <span className="text-sm font-black text-slate-900">{item.name}</span>
            <span className="inline-flex items-center gap-2 text-xs font-black text-emerald-700">
              <Wallet className="h-3.5 w-3.5" /> {item.saving}
            </span>
          </Link>
        ))}
      </div>

      <Link
        to="/compare/renting-in-dublin-vs-commuter-towns"
        className="no-underline mt-5 inline-flex items-center gap-2 text-xs font-black uppercase tracking-wider text-emerald-700"
      >
        Explore all commuter comparisons <ArrowRight className="h-4 w-4" />
      </Link>
    </aside>
  );
};

export default DublinCommuterWidget;
